import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  AppBar,
  Toolbar
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CustomerCatalog from './CustomerCatalog';
import BrandLogo from './BrandLogo';

const CustomerCatalogPage = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0F1114', fontFamily: 'Inter, sans-serif' }}>
      {/* Navbar */}
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#0B0D0F', borderBottom: '1px solid #20242A' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ justifyContent: 'space-between', minHeight: { xs: 68, md: 80 }, gap: 1.5 }}>
            <BrandLogo height={46} sx={{ cursor: 'pointer' }} onClick={() => navigate('/')} />
            
            <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, flexShrink: 0 }}>
              <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate('/')}
                sx={{ color: '#BDBDBD', fontWeight: 600, minHeight: 44, fontSize: { xs: '0.8rem', sm: '0.875rem' }, px: { xs: 1, sm: 2 } }}
              >
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Back to Home</Box>
                <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Back</Box>
              </Button>
              <Button
                startIcon={<AdminIcon />}
                onClick={() => navigate('/admin')}
                variant="outlined"
                sx={{
                  color: '#F4F6F8',
                  borderColor: '#3A4047',
                  borderRadius: 1.5,
                  fontWeight: 600,
                  px: { xs: 1.5, sm: 3 },
                  minHeight: 44,
                  '&:hover': {
                    borderColor: '#E13B36',
                    bgcolor: 'rgba(225,59,54,0.06)'
                  }
                }}
              >
                <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Admin Portal</Box>
                <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>Admin</Box>
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Main Content (Catalog) */}
      <Box sx={{ py: { xs: 4, md: 6 } }}>
        <Container maxWidth="xl">
          <Box sx={{ 
            p: { xs: 2, md: 4 }, 
            borderRadius: 1.5,
            bgcolor: '#15181C',
            border: '1px solid #282D33'
          }}>
            <CustomerCatalog shopName="Az Tires" />
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ bgcolor: '#08090B', color: 'white', pt: 5, pb: 4, mt: 'auto', borderTop: '1px solid #20242A' }}>
        <Container maxWidth="xl" sx={{ textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: '#94a3b8' }}>
            © {new Date().getFullYear()} AzTires Shop. General Santos City, South Cotabato. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default CustomerCatalogPage;
